import sample_1 from './idealProtectCrossfire.jpg';

export const idealProtectCrossfireImpressions = {
    sample_1,
};
